import { render, staticRenderFns } from "./CollectionImageCreate.vue?vue&type=template&id=2c450908&"
import script from "./CollectionImageCreate.vue?vue&type=script&lang=js&"
export * from "./CollectionImageCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports